import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import useGender from '~/shared/utils/useGender';
import { FormattedMessage } from '~/techstyle-shared/react-intl';
import { useSession } from '~/techstyle-shared/redux-core';

const Wrapper = styled.div`
  ${({ theme: { styles } }) => styles.visuallyHidden};
`;

const SEOHeader = styled.h2``;

const SEOMessage = styled.div``;

const DynamicFormattedMessage = FormattedMessage;

export default function ProductGridSEO({ categoryLabel }) {
  const { isLoggedIn } = useSession();
  const { isFemale } = useGender();
  categoryLabel = categoryLabel.toLowerCase();
  if (categoryLabel === 'sports bras') {
    categoryLabel = categoryLabel.replace(/\s/g, '');
  } else {
    categoryLabel = categoryLabel.replace(/\s/g, '-');
  }

  return (
    <>
      {!isLoggedIn && isFemale && (
        <Wrapper>
          <SEOHeader>
            <DynamicFormattedMessage
              id={`top_sellers_listing.top_seller_${categoryLabel}_body_heading`}
              defaultMessage={categoryLabel}
            />
          </SEOHeader>
          <SEOMessage>
            <DynamicFormattedMessage
              id={`top_sellers_listing.top_seller_${categoryLabel}_body_copy`}
              defaultMessage={categoryLabel}
            />
          </SEOMessage>
        </Wrapper>
      )}
    </>
  );
}

ProductGridSEO.propTypes = {
  categoryLabel: PropTypes.string,
};
